.header {
  display: inline;
  align-items: center;
}

.section {
  color: var(--main-titles-inputs-600);

  & + .section:before {
    content: '/';
    font-weight: 400;
    padding: 0 8px;
    font-size: var(--body-size-large);
  }
}

.section[isClickable='true'] {
  &:hover {
    cursor: pointer;
    text-decoration: underline;
  }
}

$smallFontSize: 10, 11, 12, 13;
$fontSize: 14, 16, 18, 20, 22, 24, 32, 36, 48;
$fontWeight: 300, 400, 500, 600, 700;

@each $size in $fontSize {
  .section[fontSize='#{$size}'] {
    font-size: calc(#{$size}px + var(--dynamic-font-size-changer));
  }
}

@each $size in $smallFontSize {
  :host([fontSize='#{$size}']) {
    font-size: calc(#{$size}px + var(--dynamic-small-font-size-changer));
  }
}

@each $weight in $fontWeight {
  .section[fontWeight='#{$weight}'] {
    font-weight: #{$weight};
  }
}
